module.exports = __webpack_public_path__ + "static/img/18.d14ddec.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/18.png
// module id = Bj33
// module chunks = 0